import { useState } from "react";
import { Link } from "react-router-dom";
import { CircleHelp } from "lucide-react";
import { ARTICLES } from "./articles";
import { ALL_PAGES, findCode } from "../shell/nav";
import { toUrl } from "../shell/routes";
import { CONFIG } from "../lib/config";

// The "?" on every page: the article for the page's code (or its one-line description), related pages, and a way to
// write to support that says where the person was
export function HelpButton({ code, title }: { code?: string; title: string }) {
  const [open, setOpen] = useState(false);
  return (<>
    <button type="button" className="icon-button help-button" aria-label="Help for this page" title="Help for this page" onClick={() => setOpen(true)}><CircleHelp size={18} /></button>
    {open && <HelpPanel code={code} title={title} onClose={() => setOpen(false)} />}
  </>);
}

export function HelpPanel({ code, title, onClose }: { code?: string; title: string; onClose: () => void }) {
  const a = code ? ARTICLES[code] : undefined;
  const page = code ? findCode(code) : undefined;
  const company = (() => { try { return sessionStorage.getItem("books.lastCompanyName") ?? sessionStorage.getItem("books.lastCompany") ?? ""; } catch { return ""; } })();
  const subject = encodeURIComponent(`Help with ${title}${code ? ` (${code})` : ""}`);
  const body = encodeURIComponent(`\n\n—\nPage: ${title}${code ? ` (${code})` : ""}\nAddress: ${location.href}\nCompany: ${company}\nBrowser: ${navigator.userAgent}`);
  return (
    <div className="overlay" onMouseDown={onClose}>
      <aside className="dialog card help-panel" role="dialog" aria-label="Help" onMouseDown={(e) => e.stopPropagation()} onKeyDown={(e) => e.key === "Escape" && onClose()}>
        <h3>{a?.title ?? title}{code && <span className="code-badge">{code}</span>}</h3>
        {a ? a.body.map((p, i) => <p key={i}>{p}</p>) : <p>{page?.desc || "There's no article for this page yet."}</p>}
        {a?.steps && <ol>{a.steps.map((s) => <li key={s}>{s}</li>)}</ol>}
        {a?.see && <p className="small">See also: {a.see.map((c) => { const p = ALL_PAGES.find((x) => x.code === c); return p ? <Link key={c} to={toUrl(p.path)} onClick={onClose}>{p.title} ({c}) </Link> : null; })}</p>}
        <p className="small muted">Type any code (like SI01) in the search bar to go straight to a page. Ctrl+K opens it.</p>
        <div className="actions">
          <a className="button" href={`mailto:${CONFIG.supportEmail}?subject=${subject}&body=${body}`}>Write to support</a>
          <button className="link" autoFocus onClick={onClose}>Close</button>
        </div>
      </aside>
    </div>
  );
}
